import React from 'react'

const Loading = ({width=12}) => {
  return (
    <div class={"loader animate-spin ease-linear rounded-full border-4 border-t-4 border-t-orange-500 border-gray-100 h-"+width+" w-"+width}></div>
  )
}

export default Loading